import { useContext } from "react";
import { getCompanyPhoneNumber } from "@/selectors";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

import { LargePhoneIcon } from "../../../bestrelocation/assets/LargePhoneIcon";
import { PhoneIcon } from "../../../bestrelocation/assets/PhoneIcon";
import BasePhoneLink from "../../../components/BaseComponents/BasePhoneLink";
import { CompanyContext } from "../../../components/CompanyList/CompanyContext";
import { twMerge } from "../../../helpers/twMerge";

const DEFAULT_CTA_TEXT = "Call Now";

export const PhoneIconLink = ({
	phoneCtaText = DEFAULT_CTA_TEXT,
	className,
}) => {
	const { company } = useContext(CompanyContext);

	const phoneNumber = useSelector((state) =>
		getCompanyPhoneNumber(state, { company }),
	);

	return (
		<BasePhoneLink
			company={company}
			className={twMerge("tw:flex tw:flex-1", className)}
		>
			<div className="tw:relative tw:flex tw:w-full tw:items-center tw:justify-center tw:gap-2 tw:rounded-[12px] tw:px-2 tw:py-3 tw:ring-2 tw:ring-[#0756C0] tw:ring-inset tw:lg:p-0 tw:lg:ring-0">
				<div className="tw:inline-flex tw:text-[#0756C0]">
					<LargePhoneIcon className="tw:hidden tw:text-5xl tw:lg:inline-block" />
					<PhoneIcon className="tw:inline-block tw:text-xl tw:lg:hidden" />
				</div>
				<div className="tw:flex tw:flex-col tw:gap-0.5">
					<div className="tw:pt-0.5 tw:text-base tw:leading-6 tw:font-semibold tw:whitespace-nowrap tw:text-[#0756C0] tw:lg:leading-normal tw:lg:font-medium tw:lg:text-[#212121]">
						{phoneCtaText}
					</div>
					<div className="tw:hidden tw:text-lg tw:leading-[26px] tw:font-bold tw:tracking-[-0.2px] tw:text-[#0756C0] tw:lg:flex tw:lg:text-xl">
						{phoneNumber}
					</div>
				</div>
			</div>
		</BasePhoneLink>
	);
};

PhoneIconLink.propTypes = {
	className: PropTypes.string,
	phoneCtaText: PropTypes.string,
};
